import React from 'react';
import { Box, Button, Grid, Typography, useMediaQuery } from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';
import Section from '../../../shared/Section/Section';
import styles from './styles';
import { sendYandexMetrikaEvent } from '../../../helpers/yandexMetrika';
import HabrLinkIcon from './HabrLinkIcon';
import StatisticItemDark from '../../../shared/Statistic/StatisticItemDark';

function Intro({ statistic, title, subtitle, ymSubmitEventType }) {
  const isXs = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <Section
      subtitle={subtitle}
      title={title}
      theme="black"
      bg="main"
      position={'right'}
    >
      <Grid container>
        <Grid item xs={12} sm={7}>
          <Typography
            variant={isXs ? 'mobileH2' : 'desktopH1'}
            color="kit.text.mainInverse"
            sx={{ width: { xs: 200, md: 'auto' } }}
          >
            ПОЛУЧИТЕ IT‍-‍ПРОФЕССИЮ И ИЗМЕНИТЕ СВОЮ ЖИЗНЬ
          </Typography>

          <Grid container sx={{ mt: { xs: 1.5, lg: 3 } }}>
            <Grid item xs={12} md={4.8} sx={{ pr: 2 }}>
              <Typography variant="desktopP2" color={'kit.text.mainInverse'}>
                Узнайте, как стать разработчиком за 3 месяца и найти стабильную
                высокооплачиваемую работу
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                pt: { xs: 3, md: 0 },
              }}
            >
              <Box sx={{ mt: -1 }}>
                <HabrLinkIcon />
              </Box>
            </Grid>
            <Grid item xs={7} sm={6} sx={{ pr: 2, mt: { xs: 1, lg: 6 } }}>
              <Typography
                variant="desktopP3Helper"
                color={'kit.text.mainInverse'}
              >
                *По версии посетителей портала Хабр в 2023г.
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={styles.statWrapper}>
            {statistic.map(({ id, ...item }) => (
              <Grid item xs={9.5} lg={4.7} sx={styles.statItem} key={id}>
                <StatisticItemDark key={id} {...item} />
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Box sx={styles.linkWrapper}>
            <Link href="/#program" sx={styles.link}>
              <Button
                size="large"
                variant="kitPrimary"
                onClick={() => sendYandexMetrikaEvent(ymSubmitEventType)}
              >
                Посмотреть программы
              </Button>
            </Link>
          </Box>
        </Grid>
      </Grid>
    </Section>
  );
}

export default Intro;
